import { ArticleUiIcon } from '@/components/icons/article-ui-icon'

import { ListicleAlertIcon } from './listicle-alert-icon'
import type { ListicleCardProps } from './types'

export const ListicleCardCopy = ({ card, text }: ListicleCardProps) => {
  const { description, isTopPick, pros } = card
  return (
    <div className="space-y-6">
      {description && (
        <p
          className={`text-navy md:text-md text-base leading-relaxed tracking-tight ${!isTopPick ? 'line-clamp-5' : ''}`}
        >
          {description}
        </p>
      )}

      {pros.length > 0 && (
        <div>
          <div className="text-navy mb-3 text-xs font-bold tracking-wider uppercase">{text.whyWePicked}</div>
          <ul className="space-y-2.5">
            {pros.map((pro, idx) => (
              <li key={idx} className="text-base-minus flex items-start gap-2.5 font-medium text-slate-600 md:text-sm">
                <ArticleUiIcon id="check" viewBox="0 0 24 24" className="mt-0.5 h-4 w-4 shrink-0 text-emerald-500" />
                <span>{pro}</span>
              </li>
            ))}
          </ul>
        </div>
      )}

      {card.tradeoff && (
        <div className="text-base-minus flex items-start gap-2 border-l-2 border-amber-200 pl-3 text-slate-500 italic md:text-sm">
          <ListicleAlertIcon />
          <span>
            <span className="font-medium">{text.tradeoff}</span> {card.tradeoff}
          </span>
        </div>
      )}
    </div>
  )
}
